import React, { useState } from "react";
import copilotStore from "Stores/copilotStore";
import "./copilotRecommendation.scss";

const SUPPRESS_MS = 7 * 24 * 60 * 60 * 1000;

const suppressed = trigger => {
  try {
    const until = Number(localStorage.getItem(`sg_rec_off_${trigger}`));
    return Boolean(until) && Date.now() < until;
  } catch (e) {
    return false;
  }
};

/**
 * In-place recommendation card (the "Google Ads" model): rendered AT the
 * entity that has the problem, seeding the copilot with a fix query on click.
 * Dismissal suppresses that trigger type for 7 days.
 */
const CopilotRecommendation = ({
  trigger,
  label,
  query,
  actionLabel = "Fix with Copilot"
}) => {
  const [hidden, setHidden] = useState(false);
  if (hidden || suppressed(trigger)) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(
        `sg_rec_off_${trigger}`,
        String(Date.now() + SUPPRESS_MS)
      );
    } catch (e) {
      /* storage blocked */
    }
    setHidden(true);
  };

  return (
    <div className="copilotRec" role="status">
      <span className="copilotRec__spark">✦</span>
      <span className="copilotRec__label">{label}</span>
      <button
        type="button"
        className="copilotRec__act"
        onClick={() => copilotStore.askWithQuery(query)}
      >
        {actionLabel}
      </button>
      <button
        type="button"
        className="copilotRec__dismiss"
        aria-label="Dismiss recommendation"
        onClick={dismiss}
      >
        <i className="material-icons-outlined">close</i>
      </button>
    </div>
  );
};

export default CopilotRecommendation;
